/*eslint-disable */

import { VueEditor } from "vue2-editor";
import axios from 'axios';
import {
mapGetters,
} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'make-public-models',
  components: {
    VueEditor
  },
  props: [],
  data() {
    return {
      algorithmName:[
        'Decision Tree',
        'Naive Bias',
        'Random Forest',
        'SVM'
      ],
      algorithm:'',
      usingAlgorithm:'',
      submitted: false,
      model_name:'',
      description:'',
      selectedModelDetails:null,
      selectedModelId:'',
      makePublicFirstStep:true,
      makePublicSecondStep:false,
      predictionFilesDescribe: [],
      updatePredictionFilesDescribe:[],
      recentMostTrainedModelsList:{},
      recentMostTrainedModelsListResults:[],
      describeListNext:null,
      describeListPrev:null,
      actvClassForTooltip:'',
      editorOptions: {
        placeholder: 'Description...',
        editorToolbar: ['bold','italic','link']
      },
      editorData: '',
    }
  },
  computed: {
    ...mapGetters([
      'getModelsDetailsByIdGetters',
      'getMostUsedTrainModelForAiDashGetters',
    ]),
    getCreateAlgoListFun(){
      this.selectedModelDetails = this.$store.getters.getModelsDetailsByIdGetters.data;
      return
    },
    setInitialStatesOfModel(){
      if(this.selectedModelDetails){
        this.model_name = this.selectedModelDetails.name 
        this.algorithm = this.selectedModelDetails.display_name_algorithm 
        this.usingAlgorithm = this.selectedModelDetails.algorithm 
        this.description = this.selectedModelDetails.description || ''
      }
      return
    },
    getMostTrainedModlesListFun(){
      this.recentMostTrainedModelsList = this.$store.getters.getMostUsedTrainModelForAiDashGetters.data;
      return
    },
    setInitialStateOfMostTrainedModlesFun(){
      if(this.recentMostTrainedModelsList != undefined){
        this.recentMostTrainedModelsListResults =  this.recentMostTrainedModelsList.results
      }
      return
    },
  },
  mounted() {
    this.selectedModelId = this.$route.params.pubModelsId
    this.getCreateAlgoListFun
    this.setInitialStatesOfModel
    this.getMostTrainedModlesListFun
    this.setInitialStateOfMostTrainedModlesFun
  },
  methods: {
    backToPublicFirstStep(){
      this.makePublicSecondStep = false
      this.makePublicFirstStep = true
    },
    selectedAlgorithmFun(val) {
      this.algorithm = val
      if(this.algorithm == 'Decision Tree'){
        this.usingAlgorithm =  'decision_tree'
      }else if(this.algorithm == 'Naive Bias'){
        this.usingAlgorithm =  'naive_bayes'
      }else if(this.algorithm == 'Random Forest'){
        this.usingAlgorithm =  'random_forest'
      }else if(this.algorithm == 'SVM'){
        this.usingAlgorithm =  'svm'
      }else{
        this.algorithm = ''
        this.usingAlgorithm = ''
      }
    },
    publicModelsFormMethod(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          var formData = new FormData();
          formData.append('name', this.model_name);
          formData.append('algorithm', this.usingAlgorithm);
          formData.append('display_name_algorithm', this.algorithm);
          formData.append('description', this.description);
          this.$store.dispatch('updateModelDetailsByIDForAIFun', {data:{data:formData,id:this.selectedModelId}})
            .then((res) => {  
              toast.success(res.data.msg);
              this.$store.dispatch('getAttrOfTrainedModelsFun',{id:this.selectedModelId}).then((res)=>{
                this.predictionFilesDescribe = res.data.data.results
                this.describeListNext = res.data.data.next
                this.makePublicFirstStep = false
                this.makePublicSecondStep = true
                this.submitted =  false
              })
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
    publicModelsSecondFormMethod(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          let data = {
            input_list : this.predictionFilesDescribe,
            is_public : true
          } 
          this.$store.dispatch('updateModelDetailsByIDForAIFun', {data:{data:data,id:this.selectedModelId}})
            .then((res) => {  
              this.$router.push({ name: 'AiDashboard' })
              toast.success(res.data.msg);
              this.submitted =  false
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
    nextDescribeListMethod(url){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          axios.get(url).then((response) => {
              this.describeListNext = response.data.data.next
              this.predictionFilesDescribe = [].concat(response.data.data.results, this.predictionFilesDescribe);
              this.submitted = false
            });
          return;
        }
      })
    },
    addActvTooltipClassMethod(data){
      this.actvClassForTooltip = data
      console.log(data, "Prince Checking Input")
    },
    removeActvTooltipClassMethod(){
      this.actvClassForTooltip = ''
    }
  },
  watch:{
    getCreateAlgoListFun(){
      return this.$store.getters.getModelsDetailsByIdGetters
    },
    setInitialStatesOfModel(){
      if(this.selectedModelDetails){
        this.model_name = this.selectedModelDetails.name 
        this.algorithm = this.selectedModelDetails.display_name_algorithm 
        this.usingAlgorithm = this.selectedModelDetails.algorithm 
        this.description = this.selectedModelDetails.description || ''
      }
      return
    },
    getMostTrainedModlesListFun(){
      return this.$store.getters.getMostUsedTrainModelForAiDashGetters;
    },
    setInitialStateOfMostTrainedModlesFun(){
      if(this.recentMostTrainedModelsList != undefined){
        this.recentMostTrainedModelsListResults =  this.recentMostTrainedModelsList.results
      }
      return
    },
  }
}